// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__4PMq_","loaderOuter":"PageOverlayLoader_loaderOuter__3EIlL"};